import { Box } from '@mui/material'
import { field } from '@nozbe/watermelondb/decorators'
import { WeatherIcon } from 'assets/icons'
import Switch from 'components/form/Switch'
import { PopupSectionRow } from 'components/popup/PopupSectionRow'
import i18n from 'i18n'
import { ChangeEvent } from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import { EventDoc } from 'types/api/changes'

export interface AllDayRowProps {
  value: string
  field: ControllerRenderProps<EventDoc, any> | undefined
  setAllDay?: (allDay: string) => void
}

export default function AllDayRow(props: AllDayRowProps) {
  function onAllDayChange(allDay: boolean) {
    if (props.setAllDay) props.setAllDay(allDay ? '1' : '0')
  }
  return (
    <PopupSectionRow
      icon={<WeatherIcon />}
      actionId="all-day-button"
      actionBg
      action={() => {
        // do nothing

        onAllDayChange(props.field?.value !== '1')
      }}
      width="fit-content"
      flexGrowForRow={0}
      title={
        <Box
          display={'flex'}
          flexDirection={'row'}
          gap={8}
          alignItems={'center'}
        >
          {i18n.t('allDay')}
          <Switch
            id="all-day-event"
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              onAllDayChange(event.target.checked)
            }
            checked={props.value === '1'}
          />
        </Box>
      }
      cursor="default"
    />
  )
}
